export const legalDocumentTranslationData = [
    {
        question: "What is legal document translation?",
        answer:
            "Legal document translation refers to the process of translating legal documents from one language to another with precision and compliance, often requiring certification or notarization."
    },
    {
        question: "Do I need a certified translation?",
        answer:
            "If your documents are being submitted to courts, immigration services, or legal entities, you may require a certified translation. We provide certified translations that are certified by a professional translator."
    },
    {
        question: "How fast can I get my legal documents translated?",
        answer:
            "TTranslation turnaround times depend on the word count, document complexity, and translator availability. However, we offer expedited options to meet urgent needs."
    },
    {
        question: "Will my translation be accepted by USCIS or courts?",
        answer:
            "Yes. All certified translations from eVerbary come with a certificate of translation accuracy and meet the standards required by legal institutions, including USCIS."
    },
    {
        question: "Can you notarize the translation?",
        answer:
            "Yes. We offer notarized translation upon request for documents that require an extra layer of verification."
    },
    {
        question: "How much does it cost?",
        answer:
            "Pricing is $24.95 per page. If you have doubts about the number of pages for your document, contact us to request a quote."
    }
];

export const medicalDocumentTranslationData = [
    {
        question: "What is the field of medical translation?",
        answer:
            "The field of medical translation involves translating healthcare-related documents with precision and understanding of medical terminology."
    },
    {
        question: "Who needs medical document translation?",
        answer:
            "Anyone needing to share patient medical history, test results, or insurance records across languages."
    },
    {
        question: "Are your translations certified?",
        answer:
            "Yes. We offer certified medical translation services, and each certified translation comes with a certificate of translation accuracy."
    },
    {
        question: "What languages do you support?",
        answer:
            "We offer language services in over 65 languages."
    },
    {
        question: "We offer language services in over 65 languages.",
        answer:
            "Turnaround depends on document length and complexity, but we strive for accurate and timely translation every time. We deliver up to three pages under 24 hours. Expedited options are available in the checkout."
    },
    {
        question: "Can you translate complex medical documents?",
        answer:
            "Yes. We handle complex medical documents across specialties including oncology, cardiology, neurology, and clinical research."
    }
];

export const immigrationDocumentTranslationData = [
    {
        question: "What is a USCIS-certified translation?",
        answer:
            "It’s a full English translation with certification from a translator stating that the translation is accurate and complete, as required by USCIS."
    },
    {
        question: "Will USCIS accept your translations?",
        answer:
            "Yes. All of our translations meet USCIS requirements and include a certificate of translation. We offer a USCIS acceptance guarantee."
    },
    {
        question: "What documents do you translate?",
        answer:
            "We translate all documents needed for immigration applications, birth certificates, legal records, academic documents, and more."
    },
    {
        question: "Do you offer notarization?",
        answer:
            "Yes. We provide notarized translations upon request."
    },
    {
        question: "How quickly can I receive my translation?",
        answer:
            "Most translations are completed within 24 hours. Expedited turnarounds are available during checkout."
    },
    {
        question: "How do I start?",
        answer:
            "Upload your documents on our website, and we’ll handle the rest."
    }
];

export const financialDocumentTranslationData = [
    {
        question: "What is financial document translation?",
        answer:
            "Whether you're submitting to a regulatory body, working on a cross-border transaction, or providing multilingual financial content to stakeholders, we translate financial documents with precision."
    },
    {
        question: "Who needs financial translation services?",
        answer:
            "Banks, financial institutions, accounting firms, investors, and companies involved in cross-border activity."
    },
    {
        question: "Do you offer certified translations?",
        answer:
            "Yes. We provide certified translation services for financial statements and official filings."
    },
    {
        question: "How long does it take to translate financial documents?",
        answer:
            "Turnaround depends on document length and complexity. Most translations are completed within 24 to 72 hours, with rush options — as fast as 4 hours — available at checkout."
    },
    {
        question: "How do you ensure confidentiality?",
        answer:
            "We follow strict confidentiality protocols for all financial documents. Each translator signs a non-disclosure agreement."
    },
    {
        question: "Are your translators qualified in finance?",
        answer:
            "Yes. We use professional financial translators with experience in the financial industry."
    }
];

export const birthDocumentTranslationData = [
    {
        question: "How long does it take to get my birth certificate translated?",
        answer:
            "Our standard turnaround is 24 hours. We offer expedited options for urgent requests."
    },
    {
        question: "Is the translation accepted by USCIS?",
        answer:
            "Yes. We provide USCIS-certified translations accepted for immigration, citizenship, and visa applications."
    },
    {
        question: "Can I get my translation notarized?",
        answer:
            "Yes. We offer notarization for any certified translation upon request."
    },
    {
        question: "What if my certificate is in a foreign language?",
        answer:
            "We can translate from a foreign language to English, and our translators are native-speaking professionals."
    },
    {
        question: "How much does it cost?",
        answer:
            "Pricing is $24.95 per page."
    },
    {
        question: "Can you translate other documents like marriage certificates?",
        answer:
            "Yes. We offer certified translation services for all personal documents, including marriage certificates, diplomas, and more."
    }
];